import React from "react";
import AdsClickIcon from "@mui/icons-material/AdsClick";

const BlinkingBullseyes = ({ leftLink, rightLink }) => {
  return (
    <div>
      {leftLink && (
        <div
          style={{
            position: "fixed",
            left: "20px",
            top: "85%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            animation: "blink 1.5s infinite",
            zIndex: "2000",
          }}
        >
          <AdsClickIcon
            fontSize="large"
            sx={{ color: "red" }}
            onClick={() => window.open(leftLink)}
          />
        </div>
      )}

      {rightLink && (
        <div
          style={{
            position: "fixed",
            right: "20px",
            top: "20%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            animation: "blink 1.5s infinite",
            zIndex: "2000",
          }}
        >
          <AdsClickIcon
            fontSize="large"
            sx={{ color: "red" }}
            onClick={() => {
              console.log("Left link clicked:", leftLink);
              window.open(rightLink);
            }}
          />
        </div>
      )}

      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }
        `}
      </style>
    </div>
  );
};

export default BlinkingBullseyes;
